import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ActionCreators from '../actions';
import BrandAnalytics from '../components/BrandAnalytics';

function mapDispatchToProps(dispatch) {
  return bindActionCreators(ActionCreators, dispatch);
}

function mapStateToProps(state) {
  return {
    auth: state.auth,
    business: state.business,
    analytics: state.analytics,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BrandAnalytics);
